<img [src]="thumbnailImageUrl" [alt]="option.Name" (click)="handleOptionSelect()" />